import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import MerchantsService from "../../../services/merchants-service.js";
const ViewMerchant = () => { 
    
const [merchant, setMerchant] = useState({});
const [loading, setLoading] = useState(false);
const { id } = useParams();
const navigate = useNavigate()

    const getMerchant = () => {
        setLoading(true);
        MerchantsService.getMerchantDetails(id)
              .then(response => {
                const data =response.data.data
                setMerchant(data)
                setLoading(false);
              })
              .catch(error => {
                setLoading(false);
                try {
                  const errorMessage = error.response.data
                  toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                } catch (e){
                  toast.error( MESSAGES.SERVER_ERROR)
                }
              });
      }
    useEffect(() => {
        getMerchant();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
const back = () => {
  navigate(-1); 
}
return(
  <div>
  <LoaderOverlay loading={loading} />
  <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
  <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Merchants View Details</h4>
  <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Profile Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MERCHANT ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.merchant_id ? merchant.merchant_detail.merchant_id : '-'}</p>
                </div> */}
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MERCHANT NAME</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.merchant_name ? merchant.merchant_detail.merchant_name : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">EMAIL ADDRESS</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.email_address ? merchant.merchant_detail.email_address : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MOBILE NUMBER</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.phone_number ? merchant.merchant_detail.phone_number : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">BUSSINESS TYPE ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.business_type_id ? merchant.merchant_detail.business_type_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATUS</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.status ? merchant.merchant_detail.status : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATUS ID</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.status_id ? merchant.merchant_detail.status_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISSION GROUP</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.comm_grp_name ? merchant.merchant_detail.comm_grp_name : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">COMMISSION GROUP NAME</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.comm_grp_name ? merchant.merchant_detail.comm_grp_name : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">Registered ON</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.created_on ? merchant.merchant_detail.created_on : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED BY</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.created_by ? merchant.merchant_detail.created_by : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">UPDATED BY</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.updated_by ? merchant.merchant_detail.updated_by : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">APPROVED BY</label>
                  <p>{merchant.merchant_detail && merchant.merchant_detail.approved_by ? merchant.merchant_detail.approved_by : '-'}</p>
                </div>
              </div> */}
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PROFILE PHOTO</label><br />
                  <img style={{margin: 0}} src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Payment Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY IN BALANCE</label>
                  <p>₹{merchant.balances && merchant.balances.pay_in_balance ? merchant.balances.pay_in_balance : 0}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">PAY OUT BALANCE</label>
                  <p>₹{merchant.balances && merchant.balances.blocked_amount ? merchant.balances.blocked_amount : 0}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED BY</label>
                  <p>---</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CREATED ON</label>
                  <p>01-03-2024 21:45:43</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Address Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 1</label>
                  <p>{merchant.address_detail && merchant.address_detail.address1 ? merchant.address_detail.address1 : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ADDRESS 2</label>
                  <p>{merchant.address_detail && merchant.address_detail.address2 ? merchant.address_detail.address2 : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY ID</label>
                  <p>{merchant.address_detail && merchant.address_detail.city_id ? merchant.address_detail.city_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">CITY</label>
                  <p>{merchant.address_detail && merchant.address_detail.city ? merchant.address_detail.city : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE ID</label>
                  <p>{merchant.address_detail && merchant.address_detail.state_id ? merchant.address_detail.state_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">STATE</label>
                  <p>{merchant.address_detail && merchant.address_detail.state ? merchant.address_detail.state : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">ZIP</label>
                  <p>{merchant.address_detail && merchant.address_detail.zip ? merchant.address_detail.zip : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Bussiness Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">BUSSINESS REGISTRATION NUMBER</label>
                  <p>{merchant.business_detail && merchant.business_detail.business_registration_number ? merchant.business_detail.business_registration_number : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">INDUSTRY TYPE ID</label>
                  <p>{merchant.business_detail && merchant.business_detail.industry_type_id ? merchant.business_detail.industry_type_id : '-'}</p>
                </div>
              </div> */}
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">INDUSTRY TYPE</label>
                  <p>{merchant.business_detail && merchant.business_detail.industry_type ? merchant.business_detail.industry_type : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">DESCRIPTION</label>
                  <p>{merchant.business_detail && merchant.business_detail.description ? merchant.business_detail.description : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul className="nav nav-tabs">
      <li className="nav-item tbbtrn">
        <a className="nav-link active_tab1" id="list_per_details">Admin Information</a>
      </li>
    </ul>
    <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
      <div className="tab-pane active" id="per_details">
        <div className="panel panel-default">
          <div className="panel-body" style={{padding: '0px'}}>
            <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">USER ID</label>
                  <p>{merchant.business_detail && merchant.business_detail.description ? merchant.business_detail.description : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">FULL NAME</label>
                  <p>{merchant.admin_detail && merchant.admin_detail.full_name ? merchant.admin_detail.full_name : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">EMAIL ADDRESS</label>
                  <p>{merchant.admin_detail && merchant.admin_detail.email_address ? merchant.admin_detail.email_address : '-'}</p>
                </div>
              </div>
              <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">MOBILE NUMBER</label>
                  <p>{merchant.admin_detail && merchant.admin_detail.mobile_number ? merchant.admin_detail.mobile_number : '-'}</p>
                </div>
              </div>
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">IS VERIFICATION PENDING</label>
                  <p>{merchant.admin_detail && merchant.admin_detail.is_verification_pending ? 'true' : 'false'}</p>
                </div>
              </div> */}
              {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                  <label htmlFor="f_name">AUTO GENERATE PASSWORD</label>
                  <p>{merchant.admin_detail && merchant.admin_detail.auto_generate_password ? 'true' : 'false'}</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-success backbt">Back</button></a>
  </div>
</div>
</div>

)

} 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
  export default withAuth(connect(mapStateToProps)(ViewMerchant));